import PropTypes from 'prop-types'
import { useFormattingContext } from '../../../FormattingProvider/FormattingContext'
import { useVaultContext } from '../../VaultContextProvider'

const TimestampCell = ({ cell }) => {
  const { formats } = useVaultContext()
  const { formatter } = useFormattingContext()
  return formatter(cell.value, formats?.dateTime ?? '@MM/DD/YYYY')
}

TimestampCell.propTypes = {
  cell: PropTypes.object
}
export default TimestampCell
